module.exports = __webpack_public_path__ + "fonts/SFUIText-Regular.08e8d58f.woff2";